// ===== Interfaces =====

import {
    IAudioNotePendingSaveState,
}                                   from '../../../interfaces';

// ===== Enums =====

import {
    AUDIO_NOTE_PENDING_SAVE_STEP,
}                                   from '../../../enums';

/**
 * New audio notes finish saving in two independent async steps:
 * the media document write and the file upload.
 */
export const createPendingAudioNoteSaveState = (): IAudioNotePendingSaveState => ({
    mediaDocSaved: false,
    uploadComplete: false,
});

/**
 * Mark one save step as completed and return the updated state.
 */
export const markPendingAudioNoteSaveStepComplete = ({
    state,
    step,
}: {
    state: IAudioNotePendingSaveState,
    step: AUDIO_NOTE_PENDING_SAVE_STEP,
}): IAudioNotePendingSaveState => ({
    ...state,
    [step]: true,
});

/**
 * The inline saving spinner should only clear once both async steps finish.
 */
export const isPendingAudioNoteSaveComplete = (
    state: IAudioNotePendingSaveState,
): boolean => state.mediaDocSaved && state.uploadComplete;
